import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=a02c36e4&scoped=true"
import script from "./PermissionDenied.vue?vue&type=script&lang=js"
export * from "./PermissionDenied.vue?vue&type=script&lang=js"
import style0 from "./PermissionDenied.vue?vue&type=style&index=0&id=a02c36e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02c36e4",
  null
  
)

export default component.exports